import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationENUS from './locales/en/en-US.json';
import translationESMX from './locales/es/es-MX.json';
import { getFromStorage } from './scripts/common/StorageHelper';
import { STORAGE_PNP } from './components/common/Storage';

export const DEFAULT_LANGUAGE = 'en-US';
export const ALLOWED_LANGUAGES = ['en-US', 'es-MX']; // this is done, because we cannot export the resources below
const resources = {
  'en-US': { translation: translationENUS },
  'es-MX': { translation: translationESMX },
};

export const setLanguageBasedOnPnp = (pnpParam) => {
  let pnp = pnpParam || getFromStorage(STORAGE_PNP);
  if (pnp) {
    let testerLanguage = pnp.language;
    if (testerLanguage && testerLanguage !== DEFAULT_LANGUAGE) {
      let matchedLanguageResource = Object.keys(resources).find(
        (key) => key.toLowerCase() === testerLanguage.toLowerCase(),
      );

      if (matchedLanguageResource) {
        i18n.changeLanguage(matchedLanguageResource);
      }
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LANGUAGE, // default language
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: { escapeValue: false },
});

export default i18n;
